const muiCardHeaderTheme = (theme) => {
  theme.overrides.MuiCardHeader = {
    root: {
      padding: '10px 20px 0 20px',
      position: 'relative',
    },
    title: {
      fontSize: '20px',
      textAlign: 'center',
      display: 'inline',
      [theme.breakpoints.only('xs')]: {
        fontSize: '15px',
        textAlign: 'left',
      },
    },
    subheader: {
      display: 'inline',
      root: {
        fontSize: '2px',
      },
    },
  };
};

export default muiCardHeaderTheme;
